import { render, staticRenderFns } from "./fastvaluedeal-card-basic.vue?vue&type=template&id=6ca4cb35&scoped=true&"
import script from "./fastvaluedeal-card-basic.vue?vue&type=script&lang=js&"
export * from "./fastvaluedeal-card-basic.vue?vue&type=script&lang=js&"
import style0 from "./fastvaluedeal-card-basic.vue?vue&type=style&index=0&id=6ca4cb35&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca4cb35",
  null
  
)

export default component.exports